import { combineReducers } from "redux";
import authAdminReducer from "./auth/authSlice";
import commonReducer from "./common/commonSlice";

const rootReducer = combineReducers({
  authAdminReducer,
  commonReducer,
});

export default rootReducer;
